import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  ConditionGroup,
  ConditionItem,
  Conditions,
} from '@shared/models/preview/conditions';

@Component({
  selector: 'app-conditions',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './conditions.component.html',
  styleUrl: './conditions.component.scss',
})
export class ConditionsComponent {
  @Input({ required: true }) conditions!: Conditions;

  // ----- Type guards -----
  isGroup(node: ConditionGroup | ConditionItem): node is ConditionGroup {
    return (node as ConditionGroup).$type === '@view-condition-group';
  }

  isItem(node: ConditionGroup | ConditionItem): node is ConditionItem {
    return (node as ConditionItem).$type === '@view-condition-item';
  }

  // ----- Rendering helpers -----
  operatorLabel(op?: string): string {
    return (op ?? '').toUpperCase() || 'AND';
  }

  depthClass(depth: number): string {
    const capped = Math.min(Math.max(depth, 0), 8);
    return `depth-${capped}`;
  }

  // ----- TrackBy -----
  trackByIndex = (i: number) => i;

  trackByStable(node: ConditionGroup | ConditionItem, index: number): string {
    // Stable-enough key to avoid rerender flicker without relying on ids that may not exist
    const t = (node as any)?.$type ?? 'node';
    const text = (node as any)?.text ?? '';
    return `${t}:${text}:${index}`;
  }
}
